import * as React from 'react'

import { styled } from '../../../common/ui'

export class TextAndIcon extends React.Component<
  { icon: React.ReactNode; children?: React.ReactNode },
  {}
> {
  public render() {
    const { icon, children } = this.props
    return (
      <Container>
        <IconContainer>{icon}</IconContainer>
        <Children>{children}</Children>
      </Container>
    )
  }
}

const Container = styled.div`
  display: flex;
  align-content: space-between;
  margin-right: 25px;

  @media all and (max-width: 992px) {
    width: 40%;
    margin-bottom: 25px;
  }
  @media all and (max-width: 600px) {
    width: 100%;
    margin-right: 0;
  }
`
const IconContainer = styled.div`
  width: 50px;
  margin-right: 8px;
  text-align: right;
  svg {
    width: 100%;
  }
`
const Children = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  width: 100%;
`
